import { render, staticRenderFns } from "./App.vue?vue&type=template&id=32a66f83&"
var script = {}
import style0 from "flexboxgrid/dist/flexboxgrid.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports